<template>
    <!-- User Profile Health Edit Info Tab Content View From Account Profile -->
    <div>
        <div class="tabs-content-secondblock mb-7">
            <div class="row" v-if="ajaxCallinprogress">
                <div class="col-lg-12 py-5 px-3 mt-10">
                    <div class="flex-container">
                        <half-circle-spinner :animation-duration="1000" :size="60" color="#005dae" />
                    </div>
                </div>
            </div>
            <div class="row" v-if="!ajaxCallinprogress">
                <div class="col-lg-12">
                    <div class="ml-2 mr-1">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="infoHeader mt-4 pb-4">
                                    <div class="a-q-Jc-j-editcontactView mt-1">
                                        <div class="a-q-Jc-Pj-Ya-editcontactView">
                                            <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3">Blood Group
                                            </div>
                                            <div class="a-q-Jc-Lb-editcontactView">
                                                <span class="a-q-Jc-wg-editcontactView">
                                                    <v-select class="vselect-custom vselect-bloodgroup"
                                                        placeholder="Select Blood Group" :options="bloodgroup"
                                                        v-model="editHealthData.health.value.blood_group"
                                                        data-vv-scope="profile_data" data-vv-as="Blood Group"
                                                        style="width: 100%;margin-top: 7px;" name="bloodgroup">
                                                    </v-select>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important;"
                                                        v-show="errors.has('profile_data.bloodgroup')">{{errors.first('profile_data.bloodgroup')}}</span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="a-q-Jc-j-editcontactView mt-1">
                                        <div class="a-q-Jc-Pj-Ya-editcontactView">
                                            <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3">
                                                Pre-Existing Conditions
                                                <sup class="fs-14 ml-1 mandatory">
                                                    <el-tooltip class="item" effect="light"
                                                        content="The options for this field are configurable in the Settings page"
                                                        placement="right">
                                                        <i class="icon-information text-secondary"
                                                            style="font-size: 14px"></i>
                                                    </el-tooltip>
                                                </sup>
                                            </div>
                                            <div class="a-q-Jc-Lb-editcontactView">
                                                <span class="a-q-Jc-wg-editcontactView">
                                                    <multiselect name="pre-existing_conditions"
                                                        class="digi-multiselect greyblack hideDropIcon mt-2"
                                                        v-model="editHealthData.health.value.pre_existing_conditions"
                                                        :options="healthOptions" @open="getHealth"
                                                        @search-change="getHealth" :loading="pre_existing_loading"
                                                        :searchable="true" :close-on-select="true" :show-labels="false"
                                                        :multiple="true" open-direction="bottom"
                                                        data-vv-scope="profile_data" data-vv-as="Blood Group"
                                                        placeholder="Select Pre-Existing Conditions">
                                                        <template slot="afterList">
                                                            <div v-observe-visibility="getHealthAfter" />
                                                        </template>
                                                        <template slot="noOptions">
                                                            <div class="text-secondary text-center fw-600">List is Empty
                                                            </div>
                                                        </template>
                                                        <template slot="noResult">
                                                            <div class="text-secondary text-center fw-600">No Results
                                                                Found</div>
                                                        </template>
                                                    </multiselect>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important;"
                                                        v-show="errors.has('profile_data.pre-existing_conditions')">{{errors.first('profile_data.pre-existing_conditions')}}</span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="a-q-Jc-j-editcontactView mt-4">
                                        <button type="button"
                                            class="btn btn-new-green btn-smm d-flex align-items-center float-right mr-2"
                                            style="box-shadow: none;"
                                            @click="editHealthData.health.value.pre_existing_conditions = []"><img
                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/reset-icon.svg"
                                                style="width: 10px; height: 10px; margin-right: 6px;" /> Reset</button>
                                    </div>
                                    <div class="a-q-Jc-j-editcontactView mt-6">
                                        <div class="a-q-Jc-Pj-Ya-editcontactView">
                                            <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3">
                                                Allergies
                                                <sup class="fs-14 ml-1 mandatory">
                                                    <el-tooltip class="item" effect="light"
                                                        content="The options for this field are configurable in the Settings page"
                                                        placement="right">
                                                        <i class="icon-information text-secondary"
                                                            style="font-size: 14px"></i>
                                                    </el-tooltip>
                                                </sup>
                                            </div>
                                            <div class="a-q-Jc-Lb-editcontactView">
                                                <span class="a-q-Jc-wg-editcontactView">
                                                    <multiselect name="pre-existing_conditions"
                                                        class="digi-multiselect greyblack hideDropIcon mt-2"
                                                        v-model="editHealthData.health.value.allergies"
                                                        :options="healthOptions" @open="getHealth"
                                                        @search-change="getHealth" :searchable="true"
                                                        :close-on-select="true" :show-labels="false" :multiple="true"
                                                        open-direction="bottom" data-vv-scope="profile_data"
                                                        data-vv-as="Blood Group" placeholder="Select Allergies">
                                                        <template slot="afterList">
                                                            <div v-observe-visibility="getHealthAfter" />
                                                        </template>
                                                        <template slot="noOptions">
                                                            <div class="text-secondary text-center fw-600">List is Empty
                                                            </div>
                                                        </template>
                                                        <template slot="noResult">
                                                            <div class="text-secondary text-center fw-600">No Results
                                                                Found</div>
                                                        </template>
                                                    </multiselect>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important;"
                                                        v-show="errors.has('profile_data.pre-existing_conditions')">{{errors.first('profile_data.pre-existing_conditions')}}</span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="a-q-Jc-j-editcontactView mt-4">
                                        <button type="button"
                                            class="btn btn-new-green btn-smm d-flex align-items-center float-right mr-2"
                                            style="box-shadow: none;"
                                            @click="editHealthData.health.value.allergies = []"><img
                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/reset-icon.svg"
                                                style="width: 10px; height: 10px; margin-right: 6px;" /> Reset</button>
                                    </div>
                                    <div class="a-q-Jc-j-editcontactView mt-6">
                                        <div class="a-q-Jc-Pj-Ya-editcontactView">
                                            <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3">
                                                Medications
                                                <sup class="fs-14 ml-1 mandatory">
                                                    <el-tooltip class="item" effect="light"
                                                        content="The options for this field are configurable in the Settings page"
                                                        placement="right">
                                                        <i class="icon-information text-secondary"
                                                            style="font-size: 14px"></i>
                                                    </el-tooltip>
                                                </sup>
                                            </div>
                                            <div class="a-q-Jc-Lb-editcontactView">
                                                <span class="a-q-Jc-wg-editcontactView">
                                                    <multiselect name="pre-existing_conditions"
                                                        class="digi-multiselect greyblack hideDropIcon mt-2"
                                                        v-model="editHealthData.health.value.medications"
                                                        :options="healthOptions" @open="getHealth"
                                                        @search-change="getHealth" :searchable="true"
                                                        :close-on-select="true" :show-labels="false" :multiple="true"
                                                        open-direction="bottom" data-vv-scope="profile_data"
                                                        data-vv-as="Blood Group" placeholder="Select Medications">
                                                        <template slot="afterList">
                                                            <div v-observe-visibility="getHealthAfter" />
                                                        </template>
                                                        <template slot="noOptions">
                                                            <div class="text-secondary text-center fw-600">List is Empty
                                                            </div>
                                                        </template>
                                                        <template slot="noResult">
                                                            <div class="text-secondary text-center fw-600">No Results
                                                                Found</div>
                                                        </template>
                                                    </multiselect>
                                                    <span class="invalid-feedback-form text-danger"
                                                        style="text-transform: none !important;"
                                                        v-show="errors.has('profile_data.pre-existing_conditions')">{{errors.first('profile_data.pre-existing_conditions')}}</span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="a-q-Jc-j-editcontactView mt-4">
                                        <button type="button"
                                            class="btn btn-new-green btn-smm d-flex align-items-center float-right mr-2"
                                            style="box-shadow: none;"
                                            @click="editHealthData.health.value.medications = []"><img
                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/reset-icon.svg"
                                                style="width: 10px; height: 10px; margin-right: 6px;" /> Reset</button>
                                    </div>
                                    <div class="a-q-Jc-j-editcontactView mt-6">
                                        <div class="a-q-Jc-Pj-Ya-editcontactView">
                                            <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3">Medical
                                                Emergency Notes</div>
                                        </div>
                                    </div>
                                    <div class="a-q-Jc-j-editcontactView">
                                        <div class="a-q-Jc-Pj-Ya-editcontactView">
                                            <textarea v-model="editHealthData.health.value.notes" maxlength="1000"
                                                style="width: 100%; margin: 0px 0px 0px 12px; border-radius: 5px; border: 1px solid rgba(0, 0, 0, 0.16); resize: none; height: 8em; padding: 0px 10px 20px 10px; overflow-y: auto"></textarea>
                                            <span class="invalid-feedback-form text-danger"
                                                style="text-transform: none !important;"
                                                v-show="errors.has('profile_data.bloodgroup')">{{errors.first('profile_data.bloodgroup')}}</span>
                                        </div>
                                        <span class="editcharacter-count text-grey"
                                            style="margin-top: -23px; margin-right: 16px;position:absolute;">{{maxlengthcountnotes - editHealthData.health.value.notes.length}}/{{maxlengthcountnotes}}</span>
                                    </div>
                                    <div class="a-q-Jc-j-editcontactView mt-4">
                                        <button type="button"
                                            class="btn btn-new-green btn-smm d-flex align-items-center float-right mr-2"
                                            style="box-shadow: none;"
                                            @click="editHealthData.health.value.notes = ''"><img
                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/reset-icon.svg"
                                                style="width: 10px; height: 10px; margin-right: 6px;" /> Reset</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    import {
        User
    } from "./mixins/user";
    import QrcodeVue from "qrcode.vue";
    import bloodgroup from "./json/bloodgroup.json";
    import VueTextareaAutosize from "vue-textarea-autosize";
    import {
        HalfCircleSpinner
    } from "epic-spinners";
    import {
        EventBus
    } from "./eventBus/nav-bar-event.js";
    export default {
        data() {
            return {
                ajaxCallinprogress: false,
                pre_existing_loading: false,
                bloodgroup: bloodgroup,
                maxlengthcountnotes: 1000,
                healthOptions: [],
                search_key: "",
                userBasicInfo: {},
                editHealthData: {
                    health: {
                        value: {
                            blood_group: "",
                            pre_existing_conditions: [],
                            allergies: [],
                            medications: [],
                            notes: "",
                        },
                        privacy: "contacts",
                    },
                },
            }
        },
        mixins: [User],
        components: {
            QrcodeVue,
            VueTextareaAutosize,
            HalfCircleSpinner,
        },
        methods: {
            async GetUserDetails(id) {
                // this.ajaxCallinprogress = true;
                let res = await this.$http.post("/users/get_user_data", {
                    user_id: id
                });
                if (res.data.status_id == 1) {
                    this.userBasicInfo = res.data.response;
                    if ("health" in this.userBasicInfo) {
                        this.editHealthData.health.value = {
                            blood_group: this.userBasicInfo.health.value.blood_group,
                            pre_existing_conditions: this.userBasicInfo.health.value.pre_existing_conditions ||
                                [],
                            allergies: this.userBasicInfo.health.value.allergies || [],
                            medications: this.userBasicInfo.health.value.medications || [],
                            notes: this.userBasicInfo.health.value.notes || "",
                        }
                    }
                }
            },
            async getHealth(key) {
                this.pre_existing_loading = true;
                if (key) {
                    this.search_key = key;
                }
                let params = {
                    search_key: this.search_key,
                    limit: 10,
                };
                let res = await this.$http.post("/users/health/search", params);
                if (res.data.status_id == 1) {
                    this.healthOptions = res.data.response;
                    this.pre_existing_loading = false;
                }
            },
            async getHealthAfter(reached) {
                if (reached) {
                    let params = {
                        search_key: this.search_key,
                        limit: this.healthOptions.length + 10,
                    };
                    let res = await this.$http.post("/users/health/search", params);
                    if (res.data.status_id == 1) {
                        this.healthOptions = res.data.response;
                    }
                }
            },
            updateHealthInfo() {
                this.saveEditUser(this.editHealthData);
                this.$emit('updateUserData');
            },
        },
        mounted() {
            EventBus.$on("healthInformation", () => {
                this.updateHealthInfo();
            });
            EventBus.$on("hideuser", () => {
                this.hideEdit();
            });
        },
        created() {
            if (this.$route.params.id) {
                this.GetUserDetails(this.$route.params.id);
            } else {
                this.GetUserDetails(this.loggedInUser._id);
            }
        },
        computed: {
            loggedInUser() {
                return this.$store.getters.loggedInUser;
            },
        },
    }
</script>

<style>
    .contact-details-tab-view.el-tabs.el-tabs--top .el-tabs__content .el-tab-pane .tabs-content-firstblock {
        border-radius: 5px;
        box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.16);
        border: solid 1px #cdd2da;
        background-color: #ffffff;
        margin: 5px 10px 15px;
    }

    .contact-details-tab-view.el-tabs.el-tabs--top .el-tabs__content .el-tab-pane .tabs-content-secondblock {
        border-radius: 5px;
        box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.16);
        border: solid 1px #cdd2da;
        background-color: #ffffff;
        margin: 5px 10px 15px;
    }

    textarea.textarea-control {
        height: auto;
    }

    textarea.textarea-control {
        display: block;
        width: 100%;
        padding: 6px 12px;
        font-size: 14px;
        line-height: 1.42857143;
        color: #4e5764;
        background-color: #fff;
        background-image: none;
        border: 1px solid #cdd2da;
        border-radius: 4px;
        -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
        box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
        -webkit-transition: border-color ease-in-out 0.15s,
            box-shadow ease-in-out 0.15s;
        -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
        -webkit-transition: border-color ease-in-out 0.15s,
            -webkit-box-shadow ease-in-out 0.15s;
        transition: border-color ease-in-out 0.15s,
            -webkit-box-shadow ease-in-out 0.15s;
        transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
        transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s,
            -webkit-box-shadow ease-in-out 0.15s;
    }

    .input-group.digi-input-group {
        border: 1px solid #cdd2da !important;
    }

    .input-group.digi-input-group>.form-control {
        position: relative !important;
        -webkit-box-flex: 1 !important;
        -webkit-flex: 1 1 auto !important;
        -ms-flex: 1 1 auto !important;
        flex: 1 1 auto !important;
        width: 1% !important;
        margin-bottom: 0 !important;
        height: 22px !important;
        padding: 6px 12px 6px 2px !important;
        color: #4e5764;
        text-decoration: underline;
        border-bottom: 1px solid transparent !important;
    }

    .input-group.digi-input-group .input-group-addon {
        padding-left: 0rem !important;
        padding-right: 0.2rem !important;
        border-bottom: 1px solid transparent !important;
        padding-top: 2px;
        cursor: pointer;
    }

    .qrcode-block-view-account {
        border-radius: 6px;
        width: 104px;
        height: 105px;
        position: relative;
        display: inline-block;
        display: block;
        border: 1px solid #005dae;
        background: #d6e2ef;
    }

    .qrcode-content-view-account {
        text-align: center;
        margin: 6px auto;
        background: #d6e2ef !important;
    }

    .qr-logo-view-account {
        position: absolute;
        margin-top: 40px;
        margin-left: 35px;
        width: 30px;
    }
</style>


// WEBPACK FOOTER //
// src/components/EditHealthView.vue